export default "__VITE_ASSET__DSOZ3Gog__"